import React from 'react'
import {Grid, Box} from '@material-ui/core'
import useStyles from './ReportsModalActions.styles'

type Props = {
  children: React.ReactNode
}

function ReportsModalActions(props: Props) {
  const classes = useStyles()

  return (
    <Box className={classes.root}>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        component="footer"
      >
        {props.children}
      </Grid>
    </Box>
  )
}

export default ReportsModalActions
